export default "__VITE_ASSET__531e5529__"